import React from "react";
import { Navigate } from "react-router-dom";

import NotFound from "NotFound";
import Health from "health";
// // New Survey Design June 2024
// import CultureAuditV2 from "survey/AuditV2/index.js";
import CultureAuditV3 from "survey/SurveyV3/index.js";
import SurveyV4 from "survey/SurveyV4/index.js";
import OTP from "survey/OTP/index.js";
import ActionPlan from "survey/ActionPlan/index.js";
import CheckIn from "survey/CheckIn/index.js";
import ReportDownload from "survey/ReportDownload/index.js";

export const routes = [
  {
    path: "/not-found",
    element: <NotFound />,
  },
  // {
  //   path: "/culture-audit-v2/:token",
  //   element: <CultureAuditV2 />,
  // },
  {
    path: "/outcome/employee/:user_token", // validate or show the email
    element: <CultureAuditV3 />,
  },
  {
    path: "/outcome/:token",  // ask for email to proceed further
    element: <CultureAuditV3 />,
  },
  {
    path: "/outcome",
    element: <CultureAuditV3 />,
  },
  {
    path: "health",
    element: <Health />,
  },
  {
    path: "/OTP/:user_token", // validate or show the email
    element: <OTP />,
  },
  {
    path:"/",
    element: <SurveyV4 />,

  },
  {
    path: "/action-plan",
    element: <ActionPlan />,
  },
  // NEW: tokenized entry points for manager emails
  {
    path: "/plan/:token",
    element: <ActionPlan />,
  },
  {
    path: "/check-in",
    element: <CheckIn />,
  },
  {
    path: "/update/:token",
    element: <CheckIn />,
  },
  {
    path: "/report-download/:trackingCode",
    element: <ReportDownload />,
  },
  { path: "*", element: <Navigate to="/not-found" /> },
];

export default routes;
